import React, {useEffect, useState} from 'react';

import AdminModuleContext from "./AdminModuleContext";
import {getDomains} from "root/DataFunctions/DomainDataFns";
import {getOrganisations} from "root/DataFunctions/OrganisationDataFns";

import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import useModalOrganisation from "root/Modals/Organisation/useModalOrganisation";
import useModalDomain from "root/Modals/Domain/useModalDomain";

const ADMIN_TITLE = 'Admin' ;

const AdminModuleProvider = (props) => {

    const [organisationData, setOrganisationData] = useState({isLoading: true, data: []});
    const [domainData, setDomainData] = useState({isLoading: true, data: []});

    const [ header, setHeader ] = useState ( ADMIN_TITLE ) ;

    const onOrgSaveComplete = ( result ) =>
    {
        if ( result !== 'cancel' )
        {
            getOrganisationData() ;
        }
    }

    const onDomainSaveComplete = ( result ) =>
    {
        if ( result !== 'cancel' )
        {
            getDomainData() ;
        }
    }

    const [ renderOrganisationModal, activateOrganisationModal ] = useModalOrganisation( onOrgSaveComplete )
    const [ renderDomainModal, activateDomainModal ] = useModalDomain( onDomainSaveComplete )

    const getDomainData = () =>
    {
        getDomains((response) =>
        {
            const domains = getDataFromResponse( response ) ;

            setDomainData( { isLoading: false, data: domains }) ;
        });
    }
    const getOrganisationData = () =>
    {
        getOrganisations((response) =>
        {
            const orgs = getDataFromResponse(response);

            setOrganisationData({isLoading: false, data: orgs});
        });
    }

    return (
        <AdminModuleContext.Provider
            value={{
                setHeader: (text) => {
                    setHeader( text ) ;
                },
                getOrganisations: () =>{
                    getOrganisationData();
                },
                getDomains: () => {
                    getDomainData() ;
                },
                isDomainLoading: domainData.isLoading,
                domainData: domainData.data,
                isOrganisationLoading: organisationData.isLoading,
                organisationData: organisationData.data,
                activateOrganisationModal: activateOrganisationModal,
                activateDomainModal: activateDomainModal,
                header: header,
            }}
        >
            {props.children}
            {renderOrganisationModal()}
            {renderDomainModal()}
        </AdminModuleContext.Provider>
    )
}

export default AdminModuleProvider;